<template>
    <div id="app" class="wrapper" style="min-width:320px">
        <div id="header" class="header">
            <div id="header_left" class="header_left">
                <img src="./images/logos/NWTULogoTransparent300x291.png" class="img-fit">
            </div>
            <div id="header_center" class="header_center">
                <img src="./images/logos/NWTUBewertungssystemTransparent300x78.png" class="img-fit">
            </div>
            <div id="header_right" class="header_right">
                <img src="./images/logos/NWTULogoTransparent300x291.png" class="img-fit">
            </div>
        </div>
        <div id="menue" v-if="visibleMenue" class="menue" style="min-width: 320px; display: flex; justify-content:flex-start">
            <kendo-menu :items="menuItems" @select="onSelect"></kendo-menu>
            <div>Benutzer: M. Mustermann KF:1 KR:1</div>
        </div>
        <div id="content">
            <div v-if="!menuClicked" id="Willkommen" class="welcome_message">
                <h2>Willkommen im NWTU Test Bewertungssystem</h2>
                <img src="./images/logos/NWTULogoTransparent300x291.png" style="align-content:center">
            </div>
            <br />
            <router-view>

            </router-view>
        </div>
        <div id="footer" class="footer">
            <div id="footer_left" class="footer_left">
                <img src="./images/pics/flag-korea-germany70x70.png" class="img-fit">
            </div>
            <div id="footer_center" class="footer_center">
                <table border="0">
                    <tr>
                        <td>
                            <strong>&copy; Nordrhein-Westf&auml;lische Taekwondo Union e.V.</strong>
                        </td>
                    </tr>
                </table>
            </div>
            <div id="footer_right" class="footer_right">
                <img src="./images/pics/flag-germany-korea70x70.png" class="img-fit">
            </div>
        </div>
    </div>
</template>

<script>
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import { Menu } from "@progress/kendo-vue-layout";
    import Vue from 'vue'
    import VueRouter from 'vue-router'
    import Home from '@/components/Home.vue';
    import LocaleLink from '@/components/LocaleLink.vue';
    import KRWertungHosinsul from '@/components/KRWertungHosinsul.vue';
    import KRWertungFreestyle from '@/components/KRWertungFreestyle.vue';
    import KRWertung from '@/components/KRWertung.vue';
    import store from '@/store/store.js';

    Vue.use(VueRouter)

    export default {
        components: {
            'kendo-menu': Menu,
            Home, LocaleLink, KRWertung, KRWertungFreestyle, KRWertungHosinsul
        },
        name: 'Home',
        props: {
            msg: String,
            menuClicked: false,
        },
        computed: {
            menuItems() {
                return this.itemsKampfrichter;
            },
        },
        data: function () {
            return {
                password: '',
                user: '',
                visibleDialog: true,
                visibleMenue: true,
                dataUsertypeItems: [
                    {
                        label: 'Kampfrichter',
                        value: 'kampfrichter',
                    },
                    {
                        label: 'Turnierorganisation',
                        value: 'turnierorganisation',
                    },
                    {
                        label: 'Fl�chenleitung',
                        value: 'flaechenleitung',
                    },
                    {
                        label: 'Administrator',
                        value: 'administrator',
                    }
                ],
                itemsKampfrichter: [
                    {
                        text: "Menu",
                        icon: "menu",
                        items: [
                            {
                                text: "Kampfrichter",
                                icon: "saturation",
                                cssClass: 'subitems',
                                items: [
                                    {
                                        text: "KR Wertung",
                                        icon: "eye",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/KRWertung",
                                        }
                                    },
                                    {
                                        text: "KR Wertung Freestyle",
                                        icon: "eye",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/KRWertungFreestyle",
                                        }
                                    },
                                    {
                                        text: "KR Wertung Hosinsul",
                                        icon: "eye",
                                        cssClass: 'subitems',
                                        data: {
                                            path: "/KRWertungHosinsul",
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        text: "Logout",
                        icon: "logout",
                        data: {
                            path: "/Logout",
                        }
                    }
                ]
            }
        },
        created() {
        },
        methods: {
            setStore() {
                store.teilnehmer_WertungTechnik = 0,
                    store.teilnehmer_WertungPraesentation = 0
            },
            onSelect(e) {
                console.log("---------------> e.item.data", e.item.data);
                if (e.item.data.path === "/Logout") {
                    this.$router.push("/");
                    window.location.reload();
                } else {
                    this.$router.push(e.item.data);
                    this.menuClicked = true;
                }
            },
            countDownTimer() {
                if (this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1;
                        this.countDownTimer();
                    }, 1000)
                }
            },
            //CorsPolicies: {
            //    Default: {
            //        Origins: "http://localhost:*,https://localhost:*,http://nwtu.eu:*,https://nwtu.eu:*,https://bewertungssystem.nwtu.eu:*,https://msbewertungssystem.nwtu.eu:*,https://192.168.0.101:*",
            //        Methods: "AllowAnyMethod,PUT,GET,PATCH,DELETE,OPTIONS,POST",
            //        Headers: "AllowAnyHeader,Authorization,Content-Type,Prefer,X-CUSTOM-HEADER",
            //        AllowCredentials: true,
            //        DisallowCredentials: false
            //    }
            //}
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    li a {
        text-decoration: none;
    }

    @import './css/main.css';
</style>

